import KeenSlider from 'keen-slider';

let mainSlider;
let thumbsSliders = [];

initMainSlider();
initThumbsSliders();

function initMainSlider() {
  const wrapEl = document.querySelector('.estate__image');
  const sliderEl = wrapEl.querySelector('.keen-slider');
  const prevEl = wrapEl.querySelector('.swiper-button-prev');
  const nextEl = wrapEl.querySelector('.swiper-button-next');
  const slideEls = wrapEl.querySelectorAll('.keen-slider__slide');

  mainSlider = new KeenSlider(sliderEl, {
    loop: true,
    slides: {
      perView: 1
    }
  });

  prevEl.onclick = () => {
    const index = mainSlider.track.details.abs;

    if(index > 0) {
      mainSlider.prev();
      thumbsSliders.forEach(slider => slider.moveToIdx(index - 1, true));
    }
  }
  nextEl.onclick = () => {
    const index = mainSlider.track.details.abs;
    if(slideEls.length > index + 1) {
      mainSlider.next();
      thumbsSliders.forEach(slider => slider.moveToIdx(index + 1, true));
    }
  }
}

function initThumbsSliders() {
  const wrapEls = document.querySelectorAll('.estate__previews');

  wrapEls.forEach(wrapEl => {
    const sliderEl = wrapEl.querySelector('.keen-slider');
  
    const thumbsSlider = new KeenSlider(sliderEl, {
      loop: false,
      slides: {
        perView: 'auto',
        spacing: 10
      }
    });

    thumbsSliders.push(thumbsSlider);

    const slideEls = wrapEl.querySelectorAll('.keen-slider__slide');
    slideEls.forEach(slideEl => {
      slideEl.addEventListener('click', () => {
        const index = +slideEl.dataset.index;

        mainSlider.moveToIdx(index);
        thumbsSliders.forEach(slider => slider.moveToIdx(index, true));
      });
    });

    thumbsSlider.on('slideChanged', () => {
      slideEls.forEach(el => el.classList.remove('is-active'));
      slideEls[thumbsSlider.track.details.abs].classList.add('is-active');
    });
  });
}

// $(function($) {
//   var sync1 = $("#mainslide");
//   var sync2 = $(".sliderthumbs");
//   var slidesPerPage = 10; //globaly define number of elements per page
//   var syncedSecondary = true;

//   sync1.owlCarousel({
//     items: 1,
//     slideSpeed: 2000,
//     nav: true,
//     autoplay: false, 
//     dots: false,
//     loop: true,
//     responsiveRefreshRate: 200,
//   })
//   .on('changed.owl.carousel', syncPosition);

//   sync2.on('initialized.owl.carousel', function() {
//       for(var i = 0; i < sync2.length; i++) {
//         $(sync2[i]).find(".owl-item").eq(0).addClass("current");
//       }
//   }).owlCarousel({
//     autoWidth: true,
//     dots: true,
//     nav: true,
//     smartSpeed: 200,
//     slideSpeed: 500,
//     slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
//     responsiveRefreshRate: 100
//   }).on('changed.owl.carousel', syncPosition2);

//   function syncPosition(el) {
//     var count = el.item.count - 1;
//     var current = el.item.index - (el.relatedTarget._clones.length / 2);

//     if (current < 0) {
//       current = count;
//     }
//     if (current > count) {
//       current = 0;
//     }

//     for(var i = 0; i < sync2.length; i++) {
//       var sync2El = $(sync2[i]);

//       sync2El.find('.owl-item').removeClass("current").eq(current).addClass('current');
//       var onscreen = sync2El.find('.owl-item.active').length - 1;
//       var start = sync2El.find('.owl-item.active').first().index();
//       var end = sync2El.find('.owl-item.active').last().index();

//       if (current > end) {
//         sync2El.data('owl.carousel').to(current, 100, true);
//       }
//       if (current < start) {
//         sync2El.data('owl.carousel').to(current - onscreen, 100, true);
//       }
//     }

//     window.lazyObserver.observe();
//   }

//   function syncPosition2(el) {
//     if (syncedSecondary) {
//       var number = el.item.index;
//       sync1.data('owl.carousel').to(number, 100, true);
//     }

//     window.lazyObserver.observe();
//   }

//   sync2.on("click", ".owl-item", function(e) {
//     e.preventDefault();
//     var number = $(this).index();
//     sync1.data('owl.carousel').to(number, 300, true);
//   });
// });